/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesAchievementRaritySchema = z.enum([
  "Common",
  "Uncommon",
  "Rare",
  "Epic",
  "Legendary",
]);
